import { GET_USER } from '../../graqhql/queries'
import { hasCommonElement } from '../../../shared/utils'

export async function beforeEach (to, from, next, { store }) {
  const { data: { user } } = await store.query({ query: GET_USER })
  const userExists = !!user
  const routeRequiresAuthorization = !!(to?.meta?.allowedUserRoles?.length)
  const userAllowedToAccessRoute = routeRequiresAuthorization
    ? !!(user?.roles?.length) && hasCommonElement(to.meta.allowedUserRoles, user.roles)
    : true

  if (!userExists) {
    // User does not exist
    // Navigate to sign in page unless already on it
    return to.name !== 'sign-in' ? next({ name: 'sign-in' }) : next()
  } else {
    // User exists
    if (to.name === 'sign-in') {
      // User is already signed in but is trying to navigate to the sign in page
      // Stay on existing page or navigate to "home" page (this experience can probably be improved)
      return next({ name: from?.name || 'home' })
    }
    // User is signed in and can either access route or not
    return userAllowedToAccessRoute ? next() : next({ name: 'unauthorized' })
  }
}

export default ({ router, store }) => {
  router.beforeEach((to, from, next) => beforeEach(to, from, next, { store }))
}
